export default {"src":"/_next/static/media/icon-bliss-center.ac706f82.svg","height":379,"width":341};